import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { DropdownBlog } from "../CustomerList";
import user from "../../../../images/user.jpg";

const BookedBlog = ({
  customersData,
  onStatusChange,
  filteredCustomers,
  searchInput,
  selectBtn,
}) => {
  const [data, setData] = useState(
    document.querySelectorAll("#booked_wrapper tbody tr")
  );

  const sort = 4;
  const activePag = useRef(0);
  const [test, settest] = useState(0);

  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  // use effect
  useEffect(() => {
    setData(document.querySelectorAll("#booked_wrapper tbody tr"));
    //chackboxFun();
  }, [test]);

  // Active pagginarion
  activePag.current === 0 && chageData(0, sort);
  // paggination
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  // Active paggination & chage data
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  return (
    <>
      <div className="table-responsive">
        <div id="booked_wrapper" className="dataTables_wrapper no-footer">
          <table
            id="example2"
            className="table card-table display mb-4 shadow-hover default-table dataTablesCard dataTable no-footer"
          >
            <thead>
              <tr role="row">
                <th className="sorting_asc">Customer Name</th>
                <th className="sorting">Email Id</th>
                <th className="sorting">Mobile Number</th>
                <th className="sorting">Total Bookings</th>
                <th className="sorting">Last Booking Date</th>
                <th className="sorting">Status</th>
                <th className="sorting">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredCustomers(customersData).map((customer) => (
                <tr key={customer.id} role="row" className="odd">
                  <td>
                    <div className="concierge-bx d-flex align-items-center">
                      <img
                        className="me-3 rounded"
                        src={customer.profilePic || user}
                        alt=""
                      />
                      <div>
                        <h5 className="fs-16 mb-0 text-nowrap">
                          <Link
                            to={`/customer-details/${customer.id}`}
                            className="text-black"
                          >
                            {customer.name}
                          </Link>
                        </h5>
                      </div>
                    </div>
                  </td>
                  <td className="text-nowrap">
                    <span>{customer.emailId}</span>
                  </td>
                  <td>
                    <div>
                      <h5 className="text-nowrap">{customer.mobileNo}</h5>
                    </div>
                  </td>
                  <td>
                    <div>
                      <h5 className="text-nowrap">{customer.totalBookings}</h5>
                    </div>
                  </td>
                  <td className="request">
                    {new Date(customer.lastBookingDate).toLocaleDateString()}
                  </td>
                  <td>
                    <p
                      className={`${
                        customer.status === "Active"
                          ? "bg-green-600"
                          : "bg-red-600"
                      } text-center font-semibold px-3 py-2 rounded-md text-white`}
                    >
                      {customer.status}
                    </p>
                  </td>
                  <td>
                    <DropdownBlog />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-3">
            <div className="dataTables_info">
              Showing {activePag.current * sort + 1} to{" "}
              {data.length > (activePag.current + 1) * sort
                ? (activePag.current + 1) * sort
                : data.length}{" "}
              of {data.length} entries
            </div>
            <div
              className="dataTables_paginate paging_simple_numbers mb-0"
              id="example2_paginate"
            >
              <Link
                className="paginate_button previous disabled"
                to="/customer-list"
                onClick={() =>
                  activePag.current > 0 && onClick(activePag.current - 1)
                }
              >
                <i className="fa fa-angle-double-left" aria-hidden="true"></i>
              </Link>
              <span>
                {paggination.map((number, i) => (
                  <Link
                    key={i}
                    to="/customer-list"
                    className={`paginate_button  ${
                      activePag.current === i ? "current" : ""
                    } `}
                    onClick={() => onClick(i)}
                  >
                    {number}
                  </Link>
                ))}
              </span>

              <Link
                className="paginate_button next"
                to="/customer-list"
                onClick={() =>
                  activePag.current + 1 < paggination.length &&
                  onClick(activePag.current + 1)
                }
              >
                <i className="fa fa-angle-double-right" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BookedBlog;
